import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "./store";
import http from "app/requests/axiosInstance";

export enum PaymentMethod {
  CASH = "cash",
  CREDIT_CARD = "credit_card",
}

export interface PaymentTransactionSliceState {
  id: number;
  sale?: any;
  paymentLink?: any;
  referenceNumber?: number;
  paymentMethod?: PaymentMethod;
  total: string;
  totalCents: number;
  subtotalCents: number;
  subtotal: string;
  taxCents: number;
  tax: string;
  tipsCents: number;
  tips: string;
  createdAt: string;
  updatedAt: string;
}

export const payWithCreditCard = createAsyncThunk(
  "paymentTransaction/payWithCreditCard",
  async (
    {
      // source,
        ccNumber,
        paymentTokenId,
      amount,
      name,
        email,
        phone,
      expiryMonth,
      expiryYear,
      tip,
      saleId,
      totalCents,
      subtotalCents,
      taxCents,
      tax,
      tipsCents,
      feeType,
      feeBasisPoint,
      withExistingCard,
      appointmentData,
      paidOnline,
    }: any,
    thunkAPI
  ) => {
    try {
      const { data } = await http.post(
        `/v1/payment_transactions/pay_with_credit_card`,
        {
          // source,
            ccNumber,
            paymentTokenId,
          amount,
          name,
            email,
            phone,
          expiryMonth,
          expiryYear,
          tip,
          saleId,
          totalCents,
          subtotalCents,
          taxCents,
          tax,
          tipsCents,
          withExistingCard,
          appointmentData,
          paidOnline,
          sendConfirmationEmail: true,
          // Dual-pricing card fee, recorded on the payment like the portal does.
          feeType,
          feeBasisPoint,
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const preauthWithCreditCard = createAsyncThunk(
  "paymentTransaction/preauthWithCreditCard",
  async (
    {
        ccNumber,
        paymentTokenId,
      // source,
      name,
        email,
        phone,
      expiryMonth,
      expiryYear,
      totalCents,
      subtotalCents,
      taxCents,
      tipsCents,
      feeType,
      feeBasisPoint,
      appointmentData,

    }: any,
    thunkAPI
  ) => {
    try {
      const { data } = await http.post(
        `/v1/payment_transactions/preauth_with_credit_card`,
        {
          // source,
            ccNumber,
          paymentTokenId,
          name,
            email,phone,
          expiryMonth,
          expiryYear,
          appointmentData,
          // The hold placed on the card - must match the real booking total,
          // not a stub amount, or the hold (and any later capture) is for
          // the wrong amount.
          amount: Number((totalCents / 100).toFixed(2)),
          totalCents,
          subtotalCents,
          taxCents,
          tax: taxCents ? Number((taxCents / 100).toFixed(2)) : 0.0,
          tip: tipsCents ? Number((tipsCents / 100).toFixed(2)) : 0.0,
          sendConfirmationEmail: true,
          // Dual-pricing card fee, recorded on the payment like the portal does.
          feeType,
          feeBasisPoint,
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const depositWithCreditCard = createAsyncThunk(
  "paymentTransaction/depositWithCreditCard",
  async (
    {
      ccNumber,
      paymentTokenId,
      name,
      email,
      phone,
      expiryMonth,
      expiryYear,
      totalCents,
      subtotalCents,
      taxCents,
      tipsCents,
      feeType,
      feeBasisPoint,
      appointmentData,
    }: any,
    thunkAPI
  ) => {
    try {
      const { data } = await http.post(
        `/v1/payment_transactions/deposit_with_credit_card`,
        {
          ccNumber,
          paymentTokenId,
          name,
          email,
          phone,
          expiryMonth,
          expiryYear,
          appointmentData,
          // The deposit amount itself is computed server-side from the
          // account's own depositType/depositValue - the full booking total
          // is sent so the backend can record what's still owed afterward.
          totalCents,
          subtotalCents,
          taxCents,
          tax: taxCents ? Number((taxCents / 100).toFixed(2)) : 0.0,
          tip: tipsCents ? Number((tipsCents / 100).toFixed(2)) : 0.0,
          sendConfirmationEmail: true,
          // Dual-pricing card fee, recorded on the payment like the portal does.
          feeType,
          feeBasisPoint,
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const payInPersonWithoutCreditCard = createAsyncThunk(
  "paymentTransaction/payInPersonWithoutCreditCard",
  async ({ appointmentData }: any, thunkAPI) => {
    try {
      const { data } = await http.post(
        `/v1/payment_transactions/pay_in_person_without_credit_card`,
        {
          appointmentData,
          sendConfirmationEmail: true,
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const testApiKeys = createAsyncThunk(
  "sales/testApiKeys",
  async (
    {
      acceptBlueTokenizationApi,
      acceptBlueApiKey,
      acceptBlueApiPin,
    }: {
      acceptBlueTokenizationApi?: string;
      acceptBlueApiKey: string;
      acceptBlueApiPin: string;
    },
    thunkAPI
  ) => {
    try {
      const { data } = await http.post(`/v1/sales/test_charge`, {
        acceptBlueTokenizationApi,
        acceptBlueApiKey,
        acceptBlueApiPin,
      });
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// export const update = createAsyncThunk(
// );

// export const delete = createAsyncThunk(
// );
